import type { FunctionalComponent, SVGAttributes } from 'vue'

export const PlusIcon: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ cursor: 'pointer' }}>
      <circle cx="7.4375" cy="7" r="5.89062" stroke="var(--colors-bg-icon-primary)" stroke-width="1.21875" />
      <rect
        x="4.49219"
        y="6.69531"
        width="5.89062"
        height="0.609375"
        rx="0.304688"
        fill="var(--colors-bg-icon-primary)"
        stroke="var(--colors-bg-icon-primary)"
        stroke-width="0.609375"
      />
      <rect
        x="7.13281"
        y="9.94531"
        width="5.89062"
        height="0.609375"
        rx="0.304688"
        transform="rotate(-90 7.13281 9.94531)"
        fill="var(--colors-bg-icon-primary)"
        stroke="var(--colors-bg-icon-primary)"
        stroke-width="0.609375"
      />
    </svg>
  )
}

export const PlusIcon2: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M8.59869 2H7.09719V7.256H1.83594V8.756H7.09719V14H8.59869V8.756H13.8359V7.256H8.59869V2Z" fill="var(--colors-bg-icon-secondary)" />
    </svg>
  )
}
